export default __webpack_public_path__ + "static/media/advantage5.95bf14e9.png";